import { useTranslation } from 'react-i18next'
import { PortfolioIcon } from '@/components/ui/PortfolioIcon'
import { HeroCarousel } from './HeroCarousel'

export const Hero = () => {
  const { t } = useTranslation()
  const lines = t('portfolio.hero.lines', { returnObjects: true }) as string[]
  const stats = t('portfolio.hero.stats', { returnObjects: true }) as {
    value: string
    label: string
  }[]
  const icons = ['tool', 'chip', 'cloud'] as const
  return (
    <section id="home" className="hero-section">
      <HeroCarousel />
      <div className="shell hero-inner">
        <div className="hero-copy">
          <p className="eyebrow">{t('portfolio.hero.eyebrow')}</p>
          <h1>
            {lines.map((line, i) => (
              <span key={line} className={i === 2 ? 'hero-accent' : ''}>
                {line}
              </span>
            ))}
          </h1>
          <p className="hero-description">{t('portfolio.hero.description')}</p>
          <div className="button-row">
            <a className="button primary" href="#projects">
              {t('portfolio.hero.work')}
              <PortfolioIcon name="arrow" />
            </a>
            <a className="button secondary" href="#contact">
              {t('portfolio.hero.contact')}
            </a>
          </div>
        </div>
        <div className="hero-bottom">
          <div className="hero-stats">
            {stats.map((stat, i) => (
              <div className="hero-stat" key={stat.value}>
                <PortfolioIcon name={icons[i] ?? 'chip'} />
                <div>
                  <strong>{stat.value}</strong>
                  <small>{stat.label}</small>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
